import { useState } from "react";
import { Check } from "lucide-react";
import { StarPicker } from "@/components/reviews/Stars";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/format";

const LABELS = { 1: "Non mi è piaciuto", 2: "Così così", 3: "Buono", 4: "Molto buono", 5: "Eccellente" };

export const ReviewForm = ({ token, item, onDone }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) {
      setError("Scegli un voto da 1 a 5 stelle.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await api.post(`/reviews/order/${token}`, { slug: item.slug, rating, comment });
      onDone(item.slug);
    } catch (err) {
      if (err?.response?.status === 409) onDone(item.slug);
      else setError(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-5 space-y-4" data-testid={`review-form-${item.slug}`}>
      <div className="flex flex-wrap items-center gap-3">
        <StarPicker value={rating} onChange={setRating} name={item.slug} />
        <span className="text-[16px] text-navy" aria-live="polite">{LABELS[rating] ?? ""}</span>
      </div>
      <label className="block text-[16px] font-medium text-navy">
        Il tuo commento <span className="font-normal text-slate2">(facoltativo)</span>
        <textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={600} rows={4} placeholder="Com'è stato usarlo? Cosa ti è piaciuto?" data-testid={`review-comment-${item.slug}`} className="mt-2 w-full rounded-2xl border border-navy/20 bg-ivory p-4 text-[17px] text-navy outline-none placeholder:text-slate2 focus:border-copper" />
      </label>
      {error && <p role="alert" className="text-[15px] text-destructive" data-testid={`review-error-${item.slug}`}>{error}</p>}
      <button type="submit" disabled={saving} data-testid={`review-submit-${item.slug}`} className="btn-primary h-14 w-full text-lg sm:w-auto">
        {saving ? "Invio…" : "Pubblica la recensione"}
      </button>
    </form>
  );
};

export const ReviewDone = ({ slug }) => (
  <p className="mt-5 flex items-center gap-3 rounded-2xl bg-[#166534]/10 p-4 text-[16px] text-[#166534]" role="status" data-testid={`review-done-${slug}`}>
    <Check className="h-5 w-5 shrink-0" /> Grazie! La tua recensione è pubblicata.
  </p>
);
